import { observer } from "mobx-react";
import React, { Component } from "react";

import { Fader } from "@formant/ui/component/common/Fader";

import { appStore, operateStore } from "../../stores";
import { Switch } from "../common/Switch";
import * as styles from "./TeleopLockDeviceSwitch.scss";

@observer
export class TeleopLockDeviceSwitch extends Component {
    public render() {
        return (
            <Fader
                visible={true}
                className={styles["teleop-lock-device-switch"]}
                onClick={this.onToggle}
                title="Claim the device for yourself so other users cannot teleop or send commands to it. If already connected, the session will be restarted to apply."
            >
                <div className={styles.label}>Claim device</div>
                <Switch
                    className={styles.switch}
                    state={appStore.teleopLockDevice}
                    disabled={false}
                />
            </Fader>
        );
    }

    private onToggle = async () => {
        appStore.teleopLockDevice = !appStore.teleopLockDevice;
        const session = operateStore.session;
        if (session?.getConnectionStatus?.() === "connected") {
            await session.restart();
        }
    };
}
